import { Validator } from "vee-validate";
import demographicService from '@/services/demographic';

Validator.extend("phone", {
  getMessage: field => "El numero de telefono " + field + " no es valido.",
  validate: value => value.replace(/[()\s-_]/g, "").length == 11
});

Validator.extend(
  "isBigger",
  (value, [otherValue]) => {
    return value >= otherValue;
  },
  {
    hasTarget: true
  }
);

Validator.extend("dpi", {
  getMessage: field => "El DPI no es válido",
  validate: (value) => {
    return demographicService.validateDPI(value);
  }
});

Validator.extend("nit", {
  getMessage: field => "El NIT no es válido",
  validate: (value) => {
    return demographicService.validateNIT(value);
  }
});
